import React from "react";
import InventoryReport from "./InventoryReports";

// Api/Reports/ProductPriceReport - see InventoryReports.jsx
const ProductPriceReports = () => <InventoryReport kind="price" />;

export default ProductPriceReports;
